
import React from 'react';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import Navigation from './Navigation';
import SidebarFooter from './SidebarFooter';
import UserProfile from './UserProfile';
import { ThemeSwitcher } from './ThemeSwitcher';
import AnimatedLogo from './AnimatedLogo';

type SidebarProps = {
  isMobile: boolean;
  isSidebarOpen: boolean;
  onCloseSidebar: () => void;
};

const Sidebar: React.FC<SidebarProps> = ({ 
  isMobile, 
  isSidebarOpen, 
  onCloseSidebar 
}) => {
  return (
    <aside 
      className={cn(
        "w-64 bg-slate-900 dark:bg-slate-900 text-white fixed inset-y-0 left-0 z-50 flex flex-col h-screen transition-transform duration-300 ease-in-out",
        isMobile && !isSidebarOpen ? "-translate-x-full" : "translate-x-0"
      )}
      aria-label="Main navigation"
    >
      <div className="flex flex-col h-full overflow-hidden">
        <div className="p-4 flex items-center justify-between border-b border-slate-800 shrink-0">
          <AnimatedLogo showTitle={true} onClick={onCloseSidebar} />
          
          <div className="flex items-center">
            {isMobile && (
              <Button 
                variant="ghost" 
                size="sm" 
                onClick={onCloseSidebar}
                className="p-1 text-slate-400 mr-2"
                aria-label="Close sidebar"
              >
                <X className="h-5 w-5" />
              </Button>
            )}
            <ThemeSwitcher />
          </div>
        </div>
        
        <div className="flex-1 overflow-y-auto">
          <Navigation />
        </div>
        
        <SidebarFooter onCloseSidebar={onCloseSidebar} />
        
        <div className="p-4 border-t border-slate-800 shrink-0">
          <UserProfile />
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
